var _filter, _line, _line2, _line3, _line4, _line5, _line6, _g, _line7, _line8, _line9, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizonMechanics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "400.667px",
    height: "400.666px",
    viewBox: "0 0 400.667 400.666",
    enableBackground: "new 0 0 400.667 400.666",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "objectBoundingBox",
    id: "AI_Shadow_1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0,
    dx: 0,
    result: "offsetBlurredAlpha",
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlurredAlpha"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FF7F00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 130,
    y1: 200.457,
    x2: 176,
    y2: 200.457
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FF7F00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 225,
    y1: 200.457,
    x2: 271,
    y2: 200.457
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FF7F00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 200.534,
    y1: 200.457,
    x2: 200.534,
    y2: 200.457
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FF7F00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 200.399,
    y1: 103.417,
    x2: 190.483,
    y2: 130.583
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FF7F00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 190.483,
    y1: 130.583,
    x2: 210.316,
    y2: 130.583
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FF7F00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 210.316,
    y1: 130.583,
    x2: 200.399,
    y2: 103.417
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#AI_Shadow_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M82.663,298.167c28.157,33.81,70.564,55.333,118.004,55.333s89.847-21.524,118.004-55.333H82.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#353535",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    d: "M82.663,298.167 c28.157,33.81,70.564,55.333,118.004,55.333s89.847-21.524,118.004-55.333H82.663z"
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 200.667,
    y1: 298.667,
    x2: 200.667,
    y2: 329.167
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 254.667,
    y1: 298.667,
    x2: 254.667,
    y2: 308.917
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 146.667,
    y1: 298.667,
    x2: 146.667,
    y2: 308.917
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#AI_Shadow_1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizonMechanics);
export default __webpack_public_path__ + "static/media/horizon_mechanics.7a08d837d3c8beca42876a23dd6b4112.svg";
export { ForwardRef as ReactComponent };